<div class="top-stripe">
  <p>Contact Us</p>
  <p><i icon="phone"></i>+1 (954) 292-7326</p>
</div>

<nav
  [@offcanvasTopAnimation]
  #navbar
  [ngClass]="{ scroll }"
  [ngStyle]="{ '--navbar-height': navbar_height + 'px' }"
>
  <div class="content">
    <a class="logo" routerLink="/">
      <img src="../../../assets/images/logo/logo.svg" alt="logo" />
    </a>

    <div class="hamburger" [ngClass]="{ active: !navbar_hidden }">
      <button
        aria-label="menu"
        mat-icon-button
        (click)="navbar_hidden = !navbar_hidden"
      >
        <span class="line"></span>
      </button>
    </div>

    <div class="menu {{ colapse }}" [ngClass]="{ hidden: navbar_hidden }">
      <a mat-button (click)="scrollTo('about-us')">about us</a>
      <a mat-button (click)="scrollTo('meet-the-team')">meet the team</a>
      <a mat-button (click)="scrollTo('loan-programs')">loan programs</a>
      <a mat-button (click)="scrollTo('testimonials')">testimonials</a>
      <a mat-button routerLink="privacy-policy">important disclosures</a>
      <a mat-button (click)="scrollTo('contact')">contact us</a>
    </div>
  </div>
</nav>

<div [@routeAnimations]="outlet && outlet.activatedRouteData">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
